import { useSyncExternalStore } from "react";
import networkMonitor, { NetworkMonitorState } from "./NetworkMonitor";

type Selector<T> = (state: NetworkMonitorState) => T;

// Define selector pattern with useSyncExternalStore
// Single hook with selector pattern
export function useNetworkMonitor<Selected>(
  selector: Selector<Selected>,
  equalityFn: (a: Selected, b: Selected) => boolean = Object.is
): Selected {
  // Use useSyncExternalStore to subscribe to the store
  // and return the value selected by the selector
  let lastSelectedState: Selected = selector(networkMonitor.getState());

  return useSyncExternalStore(
    networkMonitor.subscribe,
    // getSnapshot only returns new state if selector returns different value
    () => {
      const nextState = selector(networkMonitor.getState());

      if (!equalityFn(lastSelectedState, nextState)) {
        lastSelectedState = nextState;
      }

      return lastSelectedState;
    }
  );
}
